import { render } from "./ProjectDetailsPage.vue?vue&type=template&id=20e7468f&ts=true"
import script from "./ProjectDetailsPage.vue?vue&type=script&lang=ts"
export * from "./ProjectDetailsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__